










































































































































































































































































import { defineComponent, onUnmounted, PropType, ref, toRefs, getCurrentInstance } from '@vue/composition-api';
import { ViewModuleIcon, CheckCircleIcon, CloseCircleIcon } from 'tdesign-icons-vue';
import { RowEventContext } from 'tdesign-vue';
import ApplyDetailDialog from '@/renderer/components/dialog/FileApply/components/ApplyDetailDialog.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import listHandler, {
  AuditStatus,
  ApplyOperate,
  ApplyTableType,
} from '@/renderer/views/desktop/FileManagement/FileApply/composition/listHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import { FileApplyPageItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import ipc from '@/renderer/scripts/utils/ipc';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

export default defineComponent({
  name: 'FileApply',
  components: {
    ApplyDetailDialog,
    ViewModuleIcon,
    CheckCircleIcon,
    CloseCircleIcon,
  },
  props: {
    applyTableType: {
      type: Number as PropType<ApplyTableType>,
      default: ApplyTableType.Applying,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { applyTableType: tableType } = toRefs(props);
    const {
      roleMap,
      auditStatusMap,
      columns,
      tableData,
      sort,
      loadingStatus,
      methods: listMethods,
    } = listHandler(tableType);
    const {
      operateShowMap,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      methods: listOperateMethods,
    } = listOperateHandler({ ...tableData, selectedRowKeys: [], selectedList: [] });
    const resizeColumns = ref(setResizableColumns(columns.value));

    const applyNo = ref('');
    const showApplyDetail = ref(false);
    const methods = {
      init() {
        listMethods.pullList();
      },
      viewDetails(item: FileApplyPageItem, operate: ApplyOperate) {
        applyNo.value = item.applyNo;
        showApplyDetail.value = true;
      },
      rowViewDetails(context: RowEventContext<FileApplyPageItem>) {
        const { row } = context;
        applyNo.value = row.applyNo;
        showApplyDetail.value = true;
      },
      async reject(applyNo: string) {
        await listMethods.onOperate(applyNo, ApplyOperate.Reject);
        listMethods.refresh();
      },
      async agree(applyNo: string) {
        await listMethods.onOperate(applyNo, ApplyOperate.Agree);
        listMethods.refresh();
      },
      formatApplyContent(item: FileApplyPageItem) {
        return i18n_t('申请{slot1}等{slot2}个文件的{slot3}权限', {
          slot1: item.directoryList.map(dir => dir.name).join(';'),
          slot2: item.directoryList.length,
          slot3: roleMap.value[item.roleId],
        });
      },
      formatAuditUsers(item: FileApplyPageItem) {
        return item.canAuditUsers.length ? item.canAuditUsers.map(user => user.nickname).join(';') : '-';
      },
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.APPLY_LIST_FRESH, listMethods.refresh);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.APPLY_LIST_FRESH, listMethods.refresh);
    });
    methods.init();
    return {
      applyNo,
      roleMap,
      auditStatusMap,
      resizeColumns,
      tableData,
      sort,
      listMethods,
      operateShowMap,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      listOperateMethods,
      AuditStatus,
      ApplyOperate,
      ApplyTableType,
      showApplyDetail,
      loadingStatus,
      ...toRefs(tableData),
      ...methods,
    };
  },
});
